export default "__VITE_ASSET__bzkz1Ba2__"